import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { User } from 'firebase/auth';
import { SubscriptionStatusContext } from './SubscriptionStatusContext';
import { config } from '../config/environment';

export type SubscriptionStatus = {
  plano: string | null;
  token: string | null;
  loading: boolean;
  error: string | null;
};

// Tenta usar o SubscriptionStatusProvider se estiver disponível.
// Se o provider existir, reutilizamos seu status (evita chamadas duplicadas).
export function useSubscriptionStatus(user: User | null, refresh?: number) {
  // Chamamos useContext de forma estável; ctx será undefined se não houver provider.
  const ctx = useContext(SubscriptionStatusContext);

  // Mantemos hooks sendo chamados de forma estável. Se `ctx` existir,
  // o efeito fará apenas o refresh via ctx e não fará fetch local.
  const [status, setStatus] = useState<SubscriptionStatus>({ plano: null, token: null, loading: false, error: null });

  useEffect(() => {
    // Se existe provider, delegamos ao provider (evita fetch duplicado).
    if (ctx) {
      if (user && typeof refresh !== 'undefined') {
        ctx.refresh();
      }
      return;
    }

    if (!user) {
      setStatus({ plano: null, token: null, loading: false, error: null });
      return;
    }
    setStatus(s => ({ ...s, loading: true }));
    // Busca status do backend Java Spring Boot
  axios.get(`${config.apiUrl}/api/user/status?googleId=${user.uid}`)
      .then(res => {
        setStatus({ plano: res.data.plano, token: res.data.token, loading: false, error: null });
      })
      .catch(err => {
        setStatus({ plano: null, token: null, loading: false, error: err.message });
      });
  }, [user, refresh, ctx]);

  return ctx ? ctx.status : status;
}
